import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3A2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;